import { firestoreAction } from 'vuexfire'
import { quizCollection } from "../plugins/firebase";
import { QUESTION_TYPES } from "../views/EditQuiz";

export const playStore = {
    state: {
        players: [],
        votes: [],
    },
    mutations: {
        setQuizzes: (state, quizzes) => state.quizzes = quizzes
    },
    actions: {
        loadPlayers: firestoreAction(({ bindFirestoreRef }, quiz) => {
            return bindFirestoreRef('players', quizCollection.doc(quiz.id).collection("players").orderBy("created", "desc"))
        }),
        loadVotes: firestoreAction(({ bindFirestoreRef }, quiz) => {
            return bindFirestoreRef('votes', quizCollection.doc(quiz.id).collection("votes"))
        }),
    }
}

export function leaderboard() {
    const players = this.$store.state.play.players.map(p => ({ userid: p.userid, name: p.id, points: 0, time: 0 }));
    const votes = this.$store.state.play.votes.map(v => ({
        ...v,
        timestamp: v.timestamp.seconds * 1000 + v.timestamp.nanoseconds / 1000
    }));

    votes.forEach(vote => {
        const question = this.quiz.questions[vote.question];
        const correct = question.correct === question.options.indexOf(vote.option) && question.type === QUESTION_TYPES.KNOWLEDGE;

        // find all votes for the current question, sort them by timestamp and map them to the index
        const sortedQuestionTimestamps = votes
            .filter(v => v.question === vote.question)
            .filter(v => question.correct === question.options.indexOf(v.option) && question.type === QUESTION_TYPES.KNOWLEDGE)
            .sort((a, b) => a.timestamp - b.timestamp);

        if (correct) {
            let player = players.find(p => p.userid === vote.userid);
            player.points += 1;
            if (typeof question.timeBonus == 'undefined' ? true : question.timeBonus)
                player.time += sortedQuestionTimestamps.length - sortedQuestionTimestamps.indexOf(vote) + 1;
        }
    });

    return players.sort((a, b) => b.time - a.time).sort((a, b) => b.points - a.points);
}